var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mypage"},[_c('InformationComponent',{staticClass:"mb-3"}),_c('LessonComponent',{staticClass:"mb-3"}),_c('ToDoDeadlineComponent',{staticClass:"mb-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }